import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../services/validation.service';
import { PagerService } from '../../services/index';
import * as $ from 'jquery/dist/jquery.min.js';
declare var jQuery: any;

@Component({
	selector: 'app-users-list',
	templateUrl: './users-list.component.html',
	styleUrls: ['./users-list.component.css']
})
export class UsersListComponent implements OnInit {
	userList: any = [];
	selectedUser: any;
	isUpdateModalSelected: any;
	updateUserForm;
	countryList: any;
	languageList: any;
	selectedUserId: any;
	languageId: any;
	countryId: any;
	selectedUserData: any;
	pager: any = {};
	pagedItems: any[];
	total: any;
	limit: any;
	pageNo: any;
	searchStr: any = '';
	isUserAvailable: boolean = true;
	time: any = 0;
	redirectUrl: any;
	activePageNo: number = 0;
	referer: string = '';
	is_group_users = false;
	group_id = false;
	prev_token = null;
	groupMemberList = [];
	prevUrl: any = null;
	from_group_list: any = false;



	constructor(private commonService: CommonService, private authService: AuthService,
		private router: Router, private activatedRoute: ActivatedRoute, private validationService: ValidationService, private pagerService: PagerService) {
		this.activatedRoute.queryParamMap.subscribe(params => {
			if (params.get('type') && params.get('type') != undefined)
				this.time = params.get('type');
		});
		this.activatedRoute.params.subscribe(params => {
			if (params['group_id'] && params['group_id'] != undefined) {
				this.group_id = params['group_id'];
				this.is_group_users = true;
			}
			if (params['prev_token'] && params['prev_token'] != undefined) {
				this.prev_token = params['prev_token'];

				if (this.prev_token.indexOf("groupList") >= 0)
					this.from_group_list = true;
			}
			this.prevUrl = params.prev_token;
		});
	}

	ngOnInit() {

		this.initializeUserList();
		this.commonService.process();
	}

	myClickFunction(pageNo) {
		if (pageNo == this.activePageNo) {
			this.router.navigate['/society-group-list/']
		}
	}

	initializeUserList() {

		$('.navbar-brand').text('Users');
		this.commonService.setTitle();
		this.updateUserForm = new FormGroup({
			name: new FormControl("", Validators.compose([
				Validators.required
			])),

			role: new FormControl("", Validators.compose([
				Validators.required
			])),

			country_id: new FormControl("", Validators.compose([
				Validators.required
			])),

			language_id: new FormControl("", Validators.compose([
				Validators.required
			])),
		});

		// Get Country List
		this.authService.getCountryList().subscribe(data => {
			if (data.success) {
				this.countryList = data.country;
			}
		});

		// Get Language List
		this.authService.getLanguageList().subscribe(data => {
			if (data.success) {
				this.languageList = data.language;
			}
		});

		this.limit = 10;
		this.pageNo = 1;

		let route = this.router.url;
		if (route.indexOf("?backUrl") !== -1) {
			var routeArr = route.split('?backUrl=');
			var decodedUri = decodeURIComponent(routeArr[1]);
			var decodedArr = decodedUri.split("&");

			var decodedPageNo = decodedArr[0].split("pageNo=");
			this.pageNo = decodedPageNo[1];
			this.activePageNo = Number(decodedPageNo[1]);

			var decodedSearchStr = decodedArr[1].split("searchStr=");
			this.searchStr = decodedSearchStr[1];

			if (!this.is_group_users)
				this.getUserList(this.pageNo, this.limit, this.searchStr);
			else
				this.getGroupMembersList(1, this.limit);
		} else if (route.indexOf("?type") !== -1) {
			var routeArr = route.split('?type=');
			this.referer = routeArr[1];
			if (!this.is_group_users)
				this.getDashboardUserList(1, this.limit, routeArr[1]);
			else
				this.getGroupMembersList(1, this.limit);
		} else {

			if (!this.is_group_users)
				this.getUserList(this.pageNo, this.limit, this.searchStr);
			else
				this.getGroupMembersList(1, this.limit);
		}

	}

	getDashboardUserList = function (pageNo, limit, type) {

		this.commonService.process();
		//for weekly date
		var starts = new Date();
		if (type == 0) {
			starts.setDate(starts.getDate() - 1);
		}
		else {
			starts.setDate(starts.getDate() - 7);
		}
		starts.setHours(0, 0, 0, 0);
		this.authService.getWeeklyUserList(pageNo, limit, true, starts).subscribe(data => {

			this.isUserAvailable = false;
			if (data.success) {

				this.isUserAvailable = true;
				this.userList = data.users.docs;
				this.total = data.users.total;
				this.setPage(pageNo, true);
				this.pageNo = pageNo;
			}
			else {
				this.groupMemberList = [];
			}
			this.commonService.hideProcess();
		});
	}

	getGroupMembersList = function (pageNo, limit) {
		this.commonService.process();

		this.authService.getGroupMembersList(pageNo, limit, this.group_id).subscribe(data => {
			if (data.success) {
				var that = this;
				if (pageNo == this.activePageNo)
					setTimeout(function () {
						jQuery("#search").val(that.searchStr);
						jQuery('#page_' + that.activePageNo).addClass('active');
						if (that.activePageNo == 1)
							jQuery('#first, #prev').addClass('disabled');
						else if (that.activePageNo == that.pager.totalPages)
							jQuery('#next, #last').addClass('disabled');
					}, 300);
				this.groupMemberList = data.members;
				this.total = data.total;
				this.setPage(pageNo, true);
				this.pageNo = pageNo;
				this.redirectUrl = 'pageNo=1&groupList=1';
			}
			else {
				this.isUserAvailable = false;
				this.userList = [];
			}
			this.commonService.hideProcess();
		});
	}

	getUserList = function (pageNo, limit, searchStr) {

		this.commonService.process();

		this.authService.StatususerList(pageNo, limit, searchStr, this.time, true).subscribe(data => {
			if (data.success) {

				var that = this;
				if (pageNo == this.activePageNo)
					setTimeout(function () {
						jQuery("#search").val(that.searchStr);
						jQuery('#page_' + that.activePageNo).addClass('active');
						if (that.activePageNo == 1)
							jQuery('#first, #prev').addClass('disabled');
						else if (that.activePageNo == that.pager.totalPages)
							jQuery('#next, #last').addClass('disabled');
					}, 100);
				this.isUserAvailable = true;
				this.userList = data.users.docs;
				this.total = data.users.total;
				this.setPage(pageNo, true);
				this.pageNo = pageNo;
				this.redirectUrl = 'pageNo=' + pageNo + '&searchStr=' + searchStr;
			} else {
				this.isUserAvailable = false;
				this.userList = [];
			}

			this.commonService.hideProcess();
		});
	}

	// Pagination
	setPage(page: number, param) {
		jQuery('.pages.active a').each(function () {
			if (parseInt($(this).text()) != page) {
				$(this).parent('li').removeClass('active');
			}
		});
		if (jQuery('#first, #prev').hasClass('disabled') && page != this.pager.totalPages && page != 1)
			jQuery('#first, #prev').removeClass('disabled');
		if (jQuery('#next, #last').hasClass('disabled') && page != this.pager.totalPages)
			jQuery('#next, #last').removeClass('disabled');
		if (page < 1 || page > this.pager.totalPages) {
			return;
		}
		this.pager = this.pagerService.getPager(this.total, page);

		// get current page of items
		if (!this.is_group_users)
			this.pagedItems = this.userList.slice(this.pager.startIndex, this.pager.endIndex + 1);
		else
			this.pagedItems = this.groupMemberList.slice(this.pager.startIndex, this.pager.endIndex + 1);
		if (!param) {
			if (this.referer != '')
				this.getDashboardUserList(page, this.limit, this.referer);
			else
				this.getUserList(page, this.limit, this.searchStr);
		}
	}
	// Update user functionality.
	updateSelectedUser = function (selectedUserData) {
		this.selectedUserData = selectedUserData
		this.selectedUserId = this.selectedUserData._id;
		// Set controls 
		this.updateUserForm.controls['name'].setValue(this.selectedUserData.name);
		if (this.selectedUserData.role == "Admin")
			this.updateUserForm.controls['role'].setValue(1);
		if (this.selectedUserData.role == "User")
			this.updateUserForm.controls['role'].setValue(2);
		this.updateUserForm.controls['language_id'].setValue(this.selectedUserData.language_id._id);
		this.updateUserForm.controls['country_id'].setValue(this.selectedUserData.country_id._id);
	}

	onSubmit = function (userData) {
		// Check form is valid or not.
		if (!this.updateUserForm.valid) {
			this.validationService.validateAllFormFields(this.updateUserForm);
			return;
		}

		this.authService.updateUser(userData, this.selectedUserId).subscribe(data => {
			if (data.success) {
				this.authService.cancelProcess();
				this.getUserList(this.pageNo, this.limit, this.searchStr);
				jQuery.growl.notice({ title: 'Success', message: data.message });
			}
			else {
				jQuery.growl.error({ title: 'Error', message: data.error });
			}
		});
	}

	// Update user status
	updateUserStatus = function (userId) {

		this.authService.updateUserStatus(userId).subscribe(data => {
			if (data.success) {
				jQuery.growl.notice({ title: 'Success', message: data.message });
				this.getUserList(1, this.limit, this.searchStr);
			} else {
				$('#chk_' + userId).click();
				$('#chk_' + userId).is(':checked') ? $('#chk_' + userId).next('span.toggler').removeClass('off') : $('#chk_' + userId).next('span.toggler').addClass('off')
				jQuery.growl.error({ title: 'Error', message: data.error });
			}
		});
	}

	// Search user
	searchUser = function () {
		this.referer = '';
		this.searchStr = jQuery("#search").val();
		this.getUserList(1, this.limit, this.searchStr);
	}
}



// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/users-list/users-list.component.ts